import React from 'react'
import MemberCard from '../components/CommitteeMembers/MemberCard'
import {MemberData} from '../components/CommitteeMembers/MemberData'
import '../styles/Team.css'
function Team() {
    const displayMemberCard = MemberData.map((data, index) => (
        <div className="team-item" key={data.name + index}>
          <MemberCard name={data.name} imgLink={data.imgLink} position={data.position} />
          
        </div>
      ));
  return (
         <>
         <h1 style={{textAlign:"center",color:"#1a1253",fontWeight:"bold",textDecoration:"underline",marginBottom:"20px"}}>OUR TEAM</h1>
         <div className="team-container-row">{displayMemberCard}</div>
         </>
        
    
  )
}

export default Team